import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { getLocale, purgeBadTranslationCache, setLocale as persistLocale } from './translateService';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(() => {
    purgeBadTranslationCache();
    return getLocale();
  });
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    purgeBadTranslationCache();
    document.documentElement.lang = locale;
    document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
  }, [locale]);

  const changeLocale = useCallback((nextLocale) => {
    const value = nextLocale === 'ar' ? 'ar' : 'en';
    persistLocale(value);
    setLocaleState(value);
    setRevision((count) => count + 1);
  }, []);

  const value = useMemo(
    () => ({
      locale,
      revision,
      setLocale: changeLocale,
    }),
    [locale, revision, changeLocale],
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
